"use strict"

import React from "react"
import ReactNative from "react-native"
import { connect } from "react-redux"
import { colors } from "app/lib/styles"
import dataStore from "app/data/dataStore"

import navBarStyles from "app/components/FSNavigator/navBarStyles"
import SharingMenu from "./components/SharingMenu"
import Loading from "app/components/Loading"
import FS from "app/components/FS"

import CommunityProfile from "./CommunityProfile"
import Progress from "./Progress"

import { fetchUser, getStateForUser } from "app/actions/users"
import { navigateTo } from "app/actions/app"

const {
  View,
  StatusBar,
  Platform,
  InteractionManager,
  StyleSheet,
  SafeAreaView,
} = ReactNative

class User extends FS.View {
  getMyUrl() {
    return null
  }

  handleSignOut = () => {
    this.props.navigator.popToTop()
  }

  initializeTabContent = () => {
    InteractionManager.runAfterInteractions(() => {
      setTimeout(() => {
        var user = this.props.user
        if (!user) {
          this.props.dispatch(fetchUser(this.props.userId))
        }
      })
    })
  }

  componentDidMount(props) {
    super.componentDidMount(props)
    if (!this.props.isRoot) {
      this.initializeTabContent()
    }
  }

  navigateToSettings = () => {
    this.props.dispatch(
      navigateTo("settings", {
        title: "Settings",
        backButtonTitle: "Profile",
      })
    )
  }

  renderNavLeftButton = () => {
    var user = this.props.user
    if (!user || Platform.OS === "web") {
      return
    }
    var color = this.props.isRoot ? colors.white : colors.gray

    return (
      <View style={navBarStyles.navButtons}>
        <SharingMenu {...this.props} style={navBarStyles.navButton} key="share">
          <FS.Icon
            style={[navBarStyles.navButtonIcon, { fontSize: 22, color: color }]}
            name="share"
          />
        </SharingMenu>
      </View>
    )
  }

  renderNavRightButton = () => {
    return (
      <View style={navBarStyles.navButtons}>
        {this.props.isRoot ? (
          <FS.Touchable
            key="settings"
            onPress={this.navigateToSettings}
            style={navBarStyles.navButton}
          >
            <FS.Icon
              style={[
                navBarStyles.navButtonIcon,
                { fontSize: 20, marginTop: 3, color: colors.white },
              ]}
              name="settings"
            />
          </FS.Touchable>
        ) : null}
      </View>
    )
  }

  renderLoading() {
    return (
      <View style={styles.container}>
        <Loading />
      </View>
    )
  }

  renderNavBar() {
    if (this.props.isRoot) {
      return (
        <View style={styles.navbarWrap}>
          {this.renderNavLeftButton()}
          <FS.Text style={styles.navbarTitle} numberOfLines={1}>
            {this.props.isRoot ? "My Profile" : ""}
          </FS.Text>
          {this.renderNavRightButton()}
        </View>
      )
    } else {
      return <View style={styles.navbarWrapDummy} />
    }
  }

  renderContent() {
    if (!this.props.user) {
      return this.renderLoading()
    } else if (this.props.isRoot) {
      if (this.props.selectedProfileTab === "progress") {
        return <Progress {...this.props} scrollViewRef={c => (this._contentRef = c)} />
      } else {
        return (
          <CommunityProfile {...this.props} scrollViewRef={c => (this._contentRef = c)} />
        )
      }
    } else {
      return (
        <CommunityProfile {...this.props} scrollViewRef={c => (this._contentRef = c)} />
      )
    }
  }

  render() {
    return (
      <SafeAreaView style={[styles.container, this.props.style]}>
        <StatusBar backgroundColor={colors.challengeBlue} />
        <View style={styles.statusBarBG} />
        {this.renderNavBar()}
        <View style={styles.content}>{this.renderContent()}</View>
      </SafeAreaView>
    )
  }
}

function mapStateToProps(state, ownProps) {
  let userId =
    ownProps.userId ||
    (ownProps.navigation.state.params || {}).userId ||
    state.app.currentUserId
  return Object.assign(
    {},
    state.profile,
    {
      user: dataStore.get("user", userId),
      app: state.app,
      nav: state.nav,
      users: state.users,
      userId: userId,
    },
    ownProps.navigation.state.params
  )
}

export default connect(mapStateToProps)(User) //needed for custom nav bar

var styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.challengeBlue,
  },
  content: {
    flex: 1,
  },
  navbarWrap: {
    height: 44,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  navbarWrapDummy: {
    height: 20,
  },
  navbarTitle: {
    flex: 1,
    color: colors.white,
    fontSize: 18,
    fontWeight: "600",
    textAlign: "center",
    letterSpacing: -0.3,
  },
  activityBadge: {
    top: 0,
    left: 24,
  },
  messagesBadge: {
    top: 0,
    left: 24,
  },
  statusBarBG: {
    height: 200,
    position: "absolute",
    top: -200,
    left: 0,
    right: 0,
    backgroundColor: colors.challengeBlue,
  },
})
